import React from "react";
import styles from "./TextArea.module.scss";
import clsx from "clsx";
import { ValidationInputState } from "../../ValidationInputState";

export interface InputTextAreaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  variant?: "default" | "transparent";
  validationState?: ValidationInputState;
}

const TextAreaBase: React.ForwardRefRenderFunction<
  HTMLTextAreaElement,
  InputTextAreaProps
> = (props, ref) => {
  const {
    variant = "default",
    className,
    validationState = undefined,
    rows = 3,
    ...inputProps
  } = props;
  return (
    <textarea
      ref={ref}
      {...inputProps}
      rows={rows}
      aria-invalid={validationState == "error"}
      className={clsx(className, styles.input, {
        [styles.inputDefault]: variant == "default",
        [styles.inputTransparent]: variant == "transparent",
        [styles.stateInvalid]: validationState == "error"
      })}
    ></textarea>
  );
};

export const TextArea = React.forwardRef(TextAreaBase);
